module.exports = __webpack_public_path__ + "img/default-prev-video-img-src.786a084a.jpg";